import { createFileRoute, Link } from '@tanstack/react-router'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { DppView } from '../ui/dpp-panel/dpp-view'

function ProductPublicPage() {
  const { gtin, batchUuid } = Route.useParams()
  const { tap } = Route.useSearch()

  return (
    <div className="min-h-screen bg-warm-50">
      <header className="bg-white border-b border-warm-200">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-between">
          <div>
            <h1 className="font-display text-lg font-bold text-warm-900">Logistics DPP</h1>
            <p className="text-xs text-warm-500">Digital Product Passport</p>
          </div>
          <span className="text-xs text-warm-400">Created by Innowise</span>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-8">
        <ErrorBoundary
          fallback={
            <div className="rounded-2xl border border-red-200 bg-red-50 px-6 py-8 text-center">
              <p className="text-red-700 font-medium">Product not found</p>
              <p className="text-sm text-red-500 mt-1">
                GTIN: {gtin} / Batch: {batchUuid}
              </p>
            </div>
          }
        >
          <Suspense
            fallback={
              <div className="space-y-4 animate-pulse">
                <div className="h-6 bg-warm-200 rounded w-1/3" />
                <div className="h-24 bg-warm-200 rounded-2xl" />
                <div className="h-24 bg-warm-200 rounded-2xl" />
                <div className="h-32 bg-warm-200 rounded-2xl" />
              </div>
            }
          >
            <DppView gtin={gtin} batchUuid={batchUuid} tap={tap} />
          </Suspense>
        </ErrorBoundary>
      </main>

      <footer className="max-w-2xl mx-auto px-4 pb-8 text-center">
        <Link
          to="/"
          className="text-xs text-terra-600 hover:text-terra-700 underline underline-offset-2"
        >
          Logistics DPP Platform
        </Link>
      </footer>
    </div>
  )
}

type ProductSearch = {
  tap?: string
}

export const Route = createFileRoute('/product/$gtin/$batchUuid')({
  validateSearch: (search: Record<string, unknown>): ProductSearch => ({
    tap: typeof search.tap === 'string' ? search.tap : undefined,
  }),
  component: ProductPublicPage,
})
